import { Box, Card, CardContent, Typography } from '@mui/material';
import React from 'react';

const CustomCard = ({ title, description, footer, minHeight, titleSize = "h5", children }) => {

    return (
        <Card
            sx={{
                borderRadius: 2,
                boxShadow: 10,
                margin: { xs: '4px', md: '4px' },                      // Responsive margin
                background: 'white',
                padding: { xs: '4px', md: '4px' },                    // Consistent internal padding
            }}
        >
            {/* Card Content */}
            <CardContent>
                {/* Title */}
                <Typography
                    gutterBottom
                    variant={titleSize}
                    component="div"
                    sx={{
                        fontSize: { xs: '1.2rem', md: '1.5rem' },           // Responsive title font size
                        fontWeight: 'bold',
                    }}
                >
                    {title}
                </Typography>

                {/* Description */}
                <Typography
                    variant="body2"
                    color="text.secondary"
                    paragraph
                    sx={{
                        fontSize: { xs: '0.9rem', md: '1rem' },             // Match font size with TextField/Select
                        lineHeight: { xs: 1.4, md: 1.6 },                   // Adjust line height for better readability
                    }}
                >
                    {description}
                </Typography>

                {/* Children (flexible content inside the card) */}
                <Box
                    sx={{
                        marginTop: { xs: '10px', md: '12px' },              // Consistent spacing between children
                    }}
                >
                    {children}
                </Box>

                {/* Footer */}
                {footer && (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        paragraph
                        sx={{
                            fontSize: { xs: '0.8rem', md: '0.9rem' },         // Slightly smaller font for footer
                            marginTop: { xs: '12px', md: '16px' },
                        }}
                    >
                        {footer}
                    </Typography>
                )}
            </CardContent>
        </Card>

    );
};

export default CustomCard;
